export const VALIDATION_MESSAGES = {
  REQUIRED: 'Campo Obrigatório',
  FORMAT_ERROR: 'Formato Inválido',
}

export const ADDRESS_TYPE_VALUES = {
  HOUSE: 'FTTH',
  CONDOMINIUM: 'FTTA',
}
